import {
	type OrderManualCreateDto,
	postOrdersManual,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useCreateOrderManual = () => {
	const { t } = useResource();
	return useMutation({
		mutationFn: processResponse((data: OrderManualCreateDto) =>
			postOrdersManual(data),
		),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.orderCreateError)}:`, error);
		},
		onSuccess: () => {
			toast.success(t(orderMutationsResource.orderCreateSuccess));
		},
	});
};
